import { TrackJS } from 'trackjs';
import { responseCategories } from './api/apiConstants';
import ResponseHandler from './api/ResponseHandler';

export const enableTrackJs = !!TrackJS && !!window.trackJsEnabled;

function isDiscardableError(error: any): boolean {
    if (!error) {
        return true;
    }

    const errorIsResponseError = ResponseHandler.isResponseError(error);
    if (errorIsResponseError) {
        if (error.errorType === responseCategories.OFFLINE
            || error.errorType === responseCategories.TIMEOUT
            || error.errorType === responseCategories.FORBIDDEN
            || error.errorType === responseCategories.NOT_LOGGED_IN) {
            return true;
        }
    }

    return false;
}

export function reportError(error: any): void {
    // Check for unit test mode.
    if (!window) {
        return;
    }

    if (isDiscardableError(error)) {
        return;
    }

    if (enableTrackJs) {
        TrackJS.track(error);
    }
}

export function configureTrackJs(userId?: string): void {
    if (enableTrackJs) {
        const config: { userId?: string } = {};

        if (userId) {
            config.userId = userId;
        }

        TrackJS.configure(config);
    }
}
